import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';

import Form from 'UI/molecules/Form';

const PasswordConfirmationField = forwardRef((props, ref) => {
  const { t } = useTranslation('userDataCard');

  const { errors, ...other } = props;

  return (
    <Form.Field>
      <Form.Label htmlFor="form_password_confirmation">
        {t('form.step2.confirmation_password.label')} *
      </Form.Label>
      <Form.Control>
        <Form.Input
          error={errors.password_confirmation}
          id="form_password_confirmation"
          name="password_confirmation"
          type="password"
          ref={ref}
          placeholder={t('form.step2.confirmation_password.placeholder')}
          {...other}
        />
        {errors.password_confirmation && (
          <Form.Error>{errors.password_confirmation?.message}</Form.Error>
        )}
      </Form.Control>
    </Form.Field>
  );
});

PasswordConfirmationField.displayName = 'PasswordConfirmationField';

PasswordConfirmationField.propTypes = {
  errors: PropTypes.object,
};

export default PasswordConfirmationField;
